/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для формы организатора совместных покупок
   */
  app.JointPurchaseOrganizerFormView = app.ValidatedFormView.extend({
    el: 'main',
    formElement: '.js-organizer',
    formName: 'organizer',
    globalErrorMsg: 'При сохранении формы организатора совместных покупок',
    events: {
      'change .js-organizer': 'validate',
      'click .js-save': 'validateChildViews',
      'click .js-edit': 'editForm',
      'keyup .js-organizer-info-field': 'checkNumberSymbols',
    },
    MAX_ORGANIZER_INFO_LENGTH: 500,
    afterRun: function (options) {
      this.organizerInfoField = this.$('.js-organizer-info-field');
      this.errorBlock = this.$('#organizer-organizer_info-error');

      if (options && options.settlement) {
        this.defaultSettlement = options.settlement;
      } else {
        this.defaultSettlement = app.settlement;
      }
      this.jpOrganizer = app.helpers.TemplateHelper.getJson('#joint-purchase-organizer-json');
      this.jpPayments = app.helpers.TemplateHelper.getJson('#joint-purchase-payments-json');
      this.jpPrepayments = app.helpers.TemplateHelper.getJson('#joint-purchase-prepayments-json');
      this.jpDeliveryAddresses = app.helpers.TemplateHelper.getJson('#joint-purchase-delivery-addresses-json');
      this.jpDeliveryPickups = app.helpers.TemplateHelper.getJson('#joint-purchase-delivery-pickups-json');
      this.jpPaymentTypes = app.helpers.TemplateHelper.getJson('#joint-purchase-payment-types-json');
      if (this.jpOrganizer && _.isObject(this.jpOrganizer)) {
        this.model.set(this.jpOrganizer);
      }
      if (!this.jpOrganizer || this.model.get('moderation_status') < 1) {
        this.initChildViews();
      }
      this.jointPurchaseBillView = new app.JointPurchaseBillView({
        el: 'aside',
        organizerModel: this.model
      });
      this.listenTo(this.model, 'error', this.resetListenerOnError);
      this.listenTo(this.jointPurchaseBillView, 'purchaseCreated', this.blockEdit);
      this.savedFormTemplate = app.helpers.TemplateHelper.getTemplate('#jp-saved-form-template');
      this.formTemplate = app.helpers.TemplateHelper.getTemplate('#jp-form-template');
      this.initConsultationFeedbackForms();
    },
    initChildViews: function () {
      var choiceCountryModel = app.countryFlag.clone(),
        jointPurchasePaymentsForm = new app.JointPurchasePaymentsForm(this.jpPayments),
        jointPurchasePrepaymentsForm = new app.JointPurchasePrepaymentsForm(this.jpPrepayments);
      this.childViews.phoneInputmaskView = new app.PhoneInputmaskView({
        el: this.$('#organizer-phone'),
        model: choiceCountryModel
      });
      this.childViews.choiceCountryView = new app.ChoiceCountryView({
        el: this.$('#organizer-phone').next('.choice-country'),
        model: choiceCountryModel
      });
      this.childViews.isPrepaymentTabsView = new app.JointPurchaseSelectPrepaymentView({
        el: '.tabs'
      });

      this.childViews.jointPurchasePaymentsFormView = new app.JointPurchasePaymentsFormView({
        el: '#fee_info_block',
        targetElement: '.js-payments',
        model: jointPurchasePaymentsForm
      });

      this.childViews.jointPurchasePrepaymentsFormView = new app.JointPurchasePaymentsFormView({
        el: '#fee_info_block',
        targetElement: '.js-prepay',
        model: jointPurchasePrepaymentsForm
      });

      this.childViews.deliveryAddressForm = new app.JointPurchaseDeliveryAddressGroupFormsView({
        groups: this.jpDeliveryAddresses,
        settlement: this.defaultSettlement
      });

      this.childViews.deliveryPickupForm = new app.JointPurchaseDeliveryPickupGroupFormsView({
        groups: this.jpDeliveryPickups,
        settlement: this.defaultSettlement
      });

      if (!this.jpDeliveryAddresses.length && !this.jpDeliveryPickups.length) {
        this.childViews.deliveryPickupForm.addDeliveryGroupCity();
      }
      this.setSettlement();
    },

    /**
     * Устанавливает идентификатор основного города.
     */
    setSettlement: function () {
      this.orgSettlement = new app.SettlementForm(this.defaultSettlement.toJSON());
      this.childViews.settlementAutocomplete = new app.SettlementAutocompleteView({
        el: this.$('.js-organizer-city'),
        settlement: this.orgSettlement,
      });
      this.childViews.settlementAutocomplete.changeSelected(null, {item: null});
      this.model.set('settlement_id', this.orgSettlement.get('settlement_id'));
      this.listenTo(this.childViews.settlementAutocomplete, 'autocompleteDone', this.changeCity);
    },

    /**
     * Изменить город
     * @param {number} id идентификатор выбранного города
     * @param {Object} model модель выбранного города
     */
    changeCity: function (id, model) {
      if (model) {
        this.orgSettlement.set(model.toJSON());
        this.model.set({
          settlement_id: id,
          settlement_name: model.get('name'),
          settlement_region: model.get('region'),
        });
      }
    },

    blockEdit: function () {
      this.$('.js-edit').attr('disabled', true);
      this.$('.js-edit-message').removeClass('example').addClass('error-message').text('Вы не можете редактировать информацию в профиле организатора, пока у вас активна совместная покупка.');
    },
    validateChildViews: function () {
      var that = this;
      $.when(
        this.childViews.deliveryAddressForm.validateAll(),
        this.childViews.deliveryPickupForm.validateAll()
      )
        .done(function () {
          that.saveToModeration();
        });
    },
    saveToModeration: function () {
      var errors = this.$('.error-message').filter(function (idx, node) {
          return $(node).text();
        }),
        firstErrorMessage;
      if (errors.length) {
        firstErrorMessage = $(errors[0]);
        this.scrollToThe(firstErrorMessage.offset().top + firstErrorMessage.height() + 100 - $(window).height() / 2);
        return;
      }
      this.toggleButton(true);
      this.listenToOnce(this.model, 'error', this.toggleButton.bind(this, false));
      this.listenToOnce(this.model, 'sync', this.setStatusOnModeration);
      this.save();
    },
    /**
     * Включает/отключает кнопку "Отправить на проверку"
     */
    toggleButton: function(state) {
      this.$('.js-save').attr('disabled', state);
    },
    /**
     * Устанавливает статут "на модерации"
     */
    setStatusOnModeration: function () {
      this.model.set('moderation_status', 1);
      this.listenToOnce(this.model, 'sync', this.renderSavedForm);
      this.save();
    },
    editForm: function () {
      this.model.set('moderation_status', 0);
      this.save();
      this.listenToOnce(this.model, 'sync', this.renderForm);
      this.okoPushEdit();
    },
    resetListenerOnError: function () {
      this.stopListening(this.model, 'sync');
    },
    renderSavedForm: function () {
      this.jpOrganizer = this.model.toJSON();
      this.updateDataVariables();
      this.$('section').html(this.savedFormTemplate({
        jpPayments: this.jpPayments,
        jpPrepayments: this.jpPrepayments,
        jpOrganizer: this.jpOrganizer,
        jpDeliveryAddresses: this.jpDeliveryAddresses,
        jpDeliveryPickups: this.jpDeliveryPickups,
        jpPaymentTypes: this.jpPaymentTypes,
        moderationStatus: this.model.get('moderation_status'),
        settlement: this.orgSettlement ? this.orgSettlement.toJSON() : null,
      }));
      this.removeChildViews();
      this.scrollToThe(0);
    },
    renderForm: function () {
      this.$('section').html(this.formTemplate({
        jpPayments: this.jpPayments,
        jpPrepayments: this.jpPrepayments,
        jpOrganizer: this.jpOrganizer,
        jpDeliveryAddresses: this.jpDeliveryAddresses,
        jpDeliveryPickups: this.jpDeliveryPickups,
        jpPaymentTypes: this.jpPaymentTypes
      }));
      this.initChildViews();
      this.updateFieldsList();
      this.scrollToThe(0);
    },
    removeChildViews: function () {
      _.each(this.childViews, function (view) {
        view.remove();
      });
    },
    updateDataVariables: function () {
      this.jpOrganizer = this.model.toJSON();
      this.jpPayments = this.childViews.jointPurchasePaymentsFormView.model.toJSON();
      this.jpPrepayments = this.childViews.jointPurchasePrepaymentsFormView.model.toJSON();
      this.jpDeliveryAddresses = this.childViews.deliveryAddressForm.groups;
      this.jpDeliveryPickups = this.childViews.deliveryPickupForm.groups;
    },
    scrollToThe: function (scrollTo) {
      $('html, body').animate({
        scrollTop: scrollTo
      }, 500);
    },
    /**
     * Фильтрует несохраненные модели из коллекции.
     * @param collection
     * @returns {array} массив сохраненных на сервер моделей
     */
    filterUnsavedModels: function (collection) {
      return collection.toJSON().filter(function (model) {
        return !!model.id;
      });
    },

    /**
     * Проверка количества введенных символов.
     */
    checkNumberSymbols: function () {
      var length = this.organizerInfoField.val().length;
      if (length > this.MAX_ORGANIZER_INFO_LENGTH) {
        this.errorBlock.text('Значение «Дополнительная информация» должно содержать максимум 500 символов.');
      } else {
        this.errorBlock.text('');
      }
    },

    /**
     * Инициализация форм консультации с менеджером
     */
    initConsultationFeedbackForms: function () {
      new app.MessageToManagerFormView();
      new app.MessageToCallMeFormContactGroupView();
    },

    /**
     * Сообщаем ОКО о нажатии на кнопку редактировать
     */
    okoPushEdit: function () {
      app.helpers.OkoHelper.push({
        'n': 'custom',
        'category': 'jp_org_profile',
        'custom_str': ['edit_profile'],
      });
    },
  });
})();

}.call(window));